function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333331;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dark_Grey_Shizzz",
  "data-name": "Dark Grey Shizzz"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1.25,135.74c-9.44-64.61,35.6-125,100.22-134.49S226.52,36.85,236,101.47c8.74,59.86-29.18,115.86-86.1,131.46l7.28,49.88,56.54-8.25,4.17,28.5-56.54,8.26,9.23,63.19L142,378.68l-9.23-63.2-56.54,8.26L72.1,295.23,128.64,287l-7.29-49.89C62.34,238.43,10,195.61,1.25,135.74Zm130.33,71.71A89.79,89.79,0,1,0,29.76,131.58,90,90,0,0,0,131.58,207.45Z"
})));

var SvgCrossCircle = function SvgCrossCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 237.21 378.68",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCrossCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CrossCircle.1faef7f2.svg";
export { ForwardRef as ReactComponent };